import { RECEIVE_FEED } from "../actions/feed";

const DEFAULT_STATE = {
  byId: {},
  allIds: [],
};

const progress = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_FEED: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      const { progressLog } = action.feed;

      progressLog.forEach((newProgress) => {
        let newId = newProgress.id;
        byId[newId] = newProgress;
        if (!allIds.includes(newId)) allIds.push(newId);
      });

      return {
        byId,
        allIds,
      };
    }
    default:
      return state;
  }
};

export default progress;
